const Footer = () => {
  return (
    <footer className="w-full text-center py-8 text-gray-800">
      &copy; Sada suw 2022
    </footer>
  );
};

export default Footer;
